/* Merlons Smartlook: deferred, consent-aware session recording. */
(function () {
  'use strict';

  var PROJECT_KEY = '99441cbec6809727187c72e4bde17d9595524f4f';
  var REGION = 'eu';
  var SDK_SRC = 'https://web-sdk.smartlook.com/recorder.js';
  var SHOPIFY_HOST = 'i2fxdi-6z.myshopify.com';
  var ALLOWED_HOSTS = {
    'i2fxdi-6z.myshopify.com': true,
    'merlons.ge': true,
    'www.merlons.ge': true
  };
  var CONTROLLER_KEY = '__merlonsSmartlookController';
  var PRIVATE_PATH = /(?:^|\/)(?:account|accounts|admin|challenge|checkout|checkouts|customer|customers|login|orders?|password|recover|register)(?:\/|$)/i;
  var PREVIEW_QUERY = /(?:^|[?&])(?:preview_theme_id|preview_key|preview_token|pb)=/i;
  var rootWindow = typeof window !== 'undefined' ? window : null;
  var rootDocument = typeof document !== 'undefined' ? document : null;

  if (!rootWindow || !rootDocument) return;

  var scriptTag = rootDocument.currentScript;
  if (!scriptTag && typeof rootDocument.querySelector === 'function') {
    scriptTag = rootDocument.querySelector('script[data-merlons-smartlook]');
  }

  function setState(state, message) {
    if (scriptTag && typeof scriptTag.setAttribute === 'function') {
      scriptTag.setAttribute('data-merlons-smartlook-state', state);
      if (message) scriptTag.setAttribute('data-merlons-smartlook-error', message);
      else if (typeof scriptTag.removeAttribute === 'function') scriptTag.removeAttribute('data-merlons-smartlook-error');
    }
    if (controller) controller.state = state;
  }

  var controller = rootWindow[CONTROLLER_KEY];
  if (controller) {
    setState(controller.state || 'waiting');
    return;
  }
  controller = { state: 'waiting' };
  rootWindow[CONTROLLER_KEY] = controller;

  function isObject(value) {
    return value !== null && typeof value === 'object';
  }

  function currentUrl() {
    if (!rootWindow.location || typeof URL === 'undefined') return undefined;
    try {
      return new URL(rootWindow.location.href || String(rootWindow.location));
    } catch (error) {
      return undefined;
    }
  }

  function isPrivatePath(url) {
    if (!url) return false;
    var path = String(url.pathname || '/');
    try {
      path = decodeURIComponent(path);
    } catch (error) {
      return true;
    }
    return PRIVATE_PATH.test(path);
  }

  function isAllowedPage() {
    var url = currentUrl();
    if (!url || url.protocol !== 'https:' || url.port !== '' || ALLOWED_HOSTS[String(url.hostname).toLowerCase()] !== true) return false;
    if (rootWindow.Shopify && rootWindow.Shopify.designMode === true) return false;
    return !PREVIEW_QUERY.test(String(url.search || '')) && !isPrivatePath(url);
  }

  function sanitizedRecordingUrl(value) {
    if (typeof value !== 'string' || !value) return value;
    if (typeof URL === 'undefined') return value.split('#')[0].split('?')[0];
    try {
      var url = new URL(value, rootWindow.location && rootWindow.location.href);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      var path = isPrivatePath(url) ? '/private' : String(url.pathname || '/').replace(/\/+/g, '/');
      return url.origin + path;
    } catch (error) {
      return value.split('#')[0].split('?')[0];
    }
  }

  function markSensitiveForms() {
    if (typeof rootDocument.querySelectorAll !== 'function') return;
    var selectors = [
      'form#MerlonsOrderRequestForm',
      'form#contact_form',
      'form#customer_login',
      'form[action*="/contact"]',
      'form[action*="/account"]',
      '[data-merlons-order-request]'
    ];
    try {
      rootDocument.querySelectorAll(selectors.join(',')).forEach(function (element) {
        if (element && typeof element.setAttribute === 'function') element.setAttribute('data-sl', 'exclude');
      });
    } catch (error) {
      // A selector failure must not prevent the store from loading.
    }
  }

  function privacyApi() {
    var shopify = rootWindow.Shopify;
    return shopify && isObject(shopify.customerPrivacy) ? shopify.customerPrivacy : undefined;
  }

  function analyticsAllowed() {
    var privacy = privacyApi();
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return undefined;
    try {
      return privacy.analyticsProcessingAllowed() === true;
    } catch (error) {
      return undefined;
    }
  }

  function smartlookApi() {
    return typeof rootWindow.smartlook === 'function' ? rootWindow.smartlook : undefined;
  }

  function initOptions() {
    return {
      region: REGION,
      interceptors: {
        url: function (data) {
          if (data && typeof data.url === 'string') data.url = sanitizedRecordingUrl(data.url);
        },
        network: function () {
          return false;
        }
      }
    };
  }

  var privacyLoadRequested = false;
  var sdkLoadRequested = false;
  var sdkLoading = false;
  var sdkInitialized = false;
  var sdkInitRequested = false;
  var sdk;
  var initialSmartlook;
  var consentOverride;

  function effectiveAnalyticsAllowed() {
    if (consentOverride === false) return false;
    return analyticsAllowed();
  }

  function hasSmartlook() {
    return rootWindow.smartlook !== undefined && rootWindow.smartlook !== null;
  }

  function createSmartlookStub() {
    if (hasSmartlook()) return;
    var stub = function () {
      stub.api.push(arguments);
    };
    stub.api = [];
    rootWindow.smartlook = stub;
  }

  function pauseRecording() {
    var currentSdk = smartlookApi();
    if (sdkInitialized && currentSdk) {
      try {
        currentSdk('pause');
      } catch (error) {
        setState('error', 'pause-failed');
        return;
      }
    }
    setState('paused');
  }

  function initializeSdk() {
    if (!isAllowedPage() || effectiveAnalyticsAllowed() !== true || sdkInitialized || sdkInitRequested) return;
    sdk = smartlookApi();
    if (!sdk || (initialSmartlook && sdk !== initialSmartlook)) {
      setState('blocked');
      return;
    }
    sdkInitRequested = true;
    setState('loading');
    try {
      sdk('init', PROJECT_KEY, initOptions(), function () {
        var currentSdk = smartlookApi();
        if (!currentSdk) {
          setState('error', 'sdk-unavailable');
          return;
        }
        sdkInitialized = true;
        if (effectiveAnalyticsAllowed() !== true || !isAllowedPage()) {
          try {
            currentSdk('pause');
          } catch (error) {
            setState('error', 'pause-failed');
            return;
          }
          setState('paused');
          return;
        }
        try {
          currentSdk('record', { forms: false, numbers: false, emails: false, ips: false });
          setState('initialized');
        } catch (error) {
          setState('error', 'sdk-record-failed');
        }
      });
    } catch (error) {
      sdkInitRequested = false;
      setState('error', 'sdk-init-failed');
    }
  }

  function resumeOrLoad() {
    if (!isAllowedPage() || effectiveAnalyticsAllowed() !== true) {
      pauseRecording();
      return;
    }
    var currentSdk = smartlookApi();
    if (sdkInitialized && currentSdk) {
      try {
        currentSdk('resume');
        setState('initialized');
      } catch (error) {
        setState('error', 'resume-failed');
      }
      return;
    }
    if (smartlookApi() && !sdkLoading) {
      initializeSdk();
      return;
    }
    if (sdkLoading || sdkLoadRequested) return;
    sdkLoadRequested = true;
    sdkLoading = true;
    setState('loading');
    createSmartlookStub();
    var script = rootDocument.createElement('script');
    script.async = true;
    script.src = SDK_SRC;
    script.onload = function () {
      sdkLoading = false;
      if (effectiveAnalyticsAllowed() !== true || !isAllowedPage()) {
        setState('paused');
        return;
      }
      initializeSdk();
    };
    script.onerror = function () {
      sdkLoading = false;
      setState('error', 'sdk-load-failed');
    };
    var parent = rootDocument.head || rootDocument.documentElement;
    if (!parent || typeof parent.appendChild !== 'function') {
      sdkLoading = false;
      setState('error', 'script-parent-unavailable');
      return;
    }
    parent.appendChild(script);
  }

  function consentChanged(event) {
    var detail = event && isObject(event.detail) ? event.detail : undefined;
    if (detail && detail.analyticsAllowed === false) {
      consentOverride = false;
    } else if (detail && detail.analyticsAllowed === true) {
      consentOverride = undefined;
    }
    var allowed = effectiveAnalyticsAllowed();
    if (allowed === true) resumeOrLoad();
    else if (allowed === false) pauseRecording();
    else {
      pauseRecording();
      setState('privacy-unavailable');
    }
  }

  function loadPrivacyApi() {
    var shopify = rootWindow.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function' || privacyLoadRequested) {
      setState('privacy-unavailable');
      return;
    }
    privacyLoadRequested = true;
    setState('waiting');
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) {
          pauseRecording();
          setState('privacy-unavailable', 'consent-api-load-failed');
          return;
        }
        consentChanged();
      });
    } catch (error) {
      setState('privacy-unavailable', 'consent-api-load-failed');
    }
  }

  function start() {
    markSensitiveForms();
    initialSmartlook = hasSmartlook() ? rootWindow.smartlook : undefined;
    if (initialSmartlook !== undefined) {
      setState('blocked', 'preexisting-smartlook');
      return;
    }
    if (!isAllowedPage()) {
      setState('blocked');
      return;
    }
    if (rootDocument && typeof rootDocument.addEventListener === 'function') {
      rootDocument.addEventListener('visitorConsentCollected', consentChanged);
    }
    var allowed = effectiveAnalyticsAllowed();
    if (allowed === true) resumeOrLoad();
    else if (allowed === false) setState('paused');
    else loadPrivacyApi();
  }

  start();
})();
